import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import ChipBase from '@/components/ui/Chip/Chip';

export const Wrapper = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: 15,
  padding: theme.spacing(6, 2.5),
  margin: theme.spacing(5, 0),
}));

export const Headline = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3.5),
  minHeight: 135,
  hyphens: 'auto',
}));

export const InfoWrapper = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.grayscale[50],
  borderRadius: 15,
  padding: theme.spacing(2.5),
  marginBottom: theme.spacing(3.5),
}));

export const Chip = styled(ChipBase)(({ theme }) => ({
  alignSelf: 'flex-start',
  marginBottom: theme.spacing(2.5),
}));
